import { Box } from "@mui/material";
import { getSecrate } from "@platformx/authoring-apis";
import { RootState } from "@platformx/authoring-state";
import { adSlotBool } from "@platformx/shared/ad-components";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import BackButton from "../BackButton/BackButton";
import PageSettingMenu from "../PageSettingList/PageSettingMenu";
import "../PageSettings/PageSettings.css";
import { PrelemSettingList } from "../utils/constants";
import { useStyles } from "./PrelemSetting.styles";

interface PageSettingProps {
  setPageId?: any;
  setPrelemId?: any;
  selectedPrelemIndex: any;
}

const PrelemSettingMenu = ({ setPageId, selectedPrelemIndex }: PageSettingProps) => {
  const page = useSelector((state: RootState) => state.page);
  const classes = useStyles();
  const [prelemModelData, setPrelemModelData] = useState(page.prelemMetaArray[selectedPrelemIndex]);
  // GAM Ad Slots are only offered when the tenant has GAM + Aditude switched on in
  // Config Manager; otherwise the legacy Google AdSense entry stays as-is.
  const [gamAdsEnabled, setGamAdsEnabled] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    setPrelemModelData(page.prelemMetaArray[selectedPrelemIndex]);
  }, [page.prelemMetaArray, selectedPrelemIndex]);

  useEffect(() => {
    let cancelled = false;
    const fetchGamConfig = async () => {
      try {
        const response: any = await getSecrate({
          provider: "googleadmanager",
          providerType: "ads",
        });
        const params = response?.authoring_getSecret?.requiredParams;
        const enabled =
          adSlotBool(params?.is_enabled?.value) && adSlotBool(params?.aditude_is_enabled?.value);
        if (!cancelled) setGamAdsEnabled(enabled);
      } catch {
        if (!cancelled) setGamAdsEnabled(false);
      }
    };
    fetchGamConfig();
    return () => {
      cancelled = true;
    };
  }, []);

  const handleShowMenuItems = (id) => {
    switch (id) {
      case "prelem_images":
        return prelemModelData?.content?.ImageCompound === undefined && id === "prelem_images"
          ? false
          : true;
      case "prelem_twitter":
        return prelemModelData?.content?.TwitterHandle === undefined && id === "prelem_twitter"
          ? false
          : true;
      case "prelem_testimonials":
        return prelemModelData?.content?.Testimonials === undefined && id === "prelem_testimonials"
          ? false
          : true;
      case "prelem_video":
        return prelemModelData?.content?.Videos === undefined &&
          prelemModelData?.PrelemName !== "Image & Video Gallery" &&
          id === "prelem_video"
          ? false
          : true;
      case "prelem_brightcove":
        return prelemModelData?.content?.PlayerType === "brightcove" && id === "prelem_brightcove"
          ? true
          : false;
      case "prelem_data_source":
        return prelemModelData?.PrelemId === "Prelem_066" && id === "prelem_data_source"
          ? true
          : false;
      case "prelem_cdp_filter":
        return (
          prelemModelData?.PrelemId === "Prelem_080" ||
          prelemModelData?.PrelemId === "Prelem_081" ||
          prelemModelData?.PrelemId === "Prelem_022"
        );
      case "prelem_personalisation":
        return prelemModelData?.content?.personalisation ? true : false;
      case "prelem_prelem_bg_color":
        return prelemModelData?.content?.prelem_bg_color ? true : false;
      case "additional_setting":
        return prelemModelData?.content?.additional_setting ? true : false;
      case "form_end_date":
      case "form_id":
      case "form_version":
        return prelemModelData?.PrelemId === "Prelem_0162";
      case "select_item_count_x_str":
        return prelemModelData?.content?.select_item_count_x_str ? true : false;
      case "prelem_settings":
        return prelemModelData?.content?.dynamic_prelem_setting?.allowed_selection_type
          ? true
          : false;
      case "google_ad_setting":
        return !gamAdsEnabled;
      case "gam_ad_setting":
        return gamAdsEnabled;
      default:
        return true;
    }
  };

  return (
    <Box className={classes.PrelemSettingBox}>
      <BackButton setPageId={setPageId} Title={t("page_prelem_setting")} />
      {PrelemSettingList.map((val, key) => {
        const { imgUrl, id } = val;
        return (
          handleShowMenuItems(id) && (
            <PageSettingMenu
              key={key}
              imgUrl={imgUrl}
              title={t(id)}
              setPageId={setPageId}
              id={id}
            />
          )
        );
      })}
    </Box>
  );
};

export default PrelemSettingMenu;
